import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import SeleccionInformesScreen from './screen';
import { ServerErrorMessage } from '../../../../../../shared/utils/error';
import { useNotifications} from '../../../../../../shared/hooks/Notifications';
import { InformesDetalleAdapter } from '../../../../../../infraestructure/persistence/rest/InformesDetalleAdapter';

export const SeleccionInformesContainer = () => {

	const api = new InformesDetalleAdapter();
	const {resultError, exceptionError, launchNotification} = useNotifications();
	
	let [ data, setData ] = useState<any>([]);
	let [isLoading, setIsLoading] = useState<boolean>(false);

	let result: any;

	const getDatosInforme = async (data: any) => {
		setIsLoading(true);
		try {
			result = await api.ListarInformeData(data);
			if(result.data && result.data!==""){
				console.log('result.data',result.data);
				setData([...result.data] || []);
			}else{resultError();}
		} catch (e) {
			let exception = ServerErrorMessage(e);
			exceptionError(exception)
		}
		setIsLoading(false);
  	};

	return (
		<>
			<SeleccionInformesScreen data={data} onFilter={getDatosInforme} isLoading={isLoading} />
		</>
	);
};

export default SeleccionInformesContainer;
function exceptionError(exception: { title: string; message: any; code?: undefined; } | { title: string; message: any; code: any; } | undefined) {
	throw new Error('Function not implemented.');
}

function resultError() {
	throw new Error('Function not implemented.');
}

function launchNotification(arg0: { type: string; title: string; message: string; }) {
	throw new Error('Function not implemented.');
}

